import { createComponent as _$createComponent } from "solid-js/web";
import { browserSettingsStore } from "../audio/settings.ts";
import { createMissionsSurface } from "../shell/missions-surface.ts";
import { ScreenShell } from "../shell/ScreenShell.tsx";

/**
 * `/missions` — FLY SINGLE MISSION, in the shell (AD-009).
 *
 * The route is one line of wiring because everything it used to hold has moved
 * to where it can be tested: the flow to `shell/model/missions-model.ts`, the
 * screens to `shell/model/missions-screens.ts`, the geometry to
 * `shell/render/*`, and the generators were always in `packages/engine`. The
 * mission still travels to `/fly` as `?m=<catalog id>&seed=<n>`, which is why
 * nothing about the flight route had to change.
 */
export function Missions() {
  return _$createComponent(ScreenShell, {
    get controller() {
      return createMissionsSurface(browserSettingsStore());
    },
    label: "Fly single mission"
  });
}